import React, {useMemo, useState} from "react";
import PropTypes from "prop-types";

import WizardPopupContext, {useCustomContext, wizardPopupAction} from "../WizardPopupContext";
import {toggleArrayValue} from "../../../FeatureCreator/FeaturesFilters/filtersFunctions";
import CheckBox from "../../../PageLayout/CheckBox";
import {getFeatureExcludedIndex, getFeatureIncludedIndex, getFeaturesExcludedObject} from "../../wizardFunctions";

const WizardPopupFeaturesExclusionFeature = (props) => {

  const {feature} = props;
  const [thumbnailLoaded, setThumbnailLoaded] = useState(true);

  const {wizardPopupState, wizardPopupDispatch} = useCustomContext(WizardPopupContext);
  const {featuresExcluded, featuresIncluded, useIncluded} = wizardPopupState;

  const featureExcludedIndex = useMemo(() => {
    return getFeatureExcludedIndex(feature, featuresExcluded)
  }, [feature, featuresExcluded]);

  const featureIncludedIndex = useMemo(() => {
    return getFeatureIncludedIndex(feature, featuresIncluded)
  }, [feature, featuresIncluded]);

  // const isChecked = featureExcludedIndex < 0 && (!featuresIncluded.length || featureIncludedIndex > -1);
  const isChecked = useIncluded ? featureIncludedIndex > -1 : featureExcludedIndex < 0;

  const toggleExcluded = () => {
    const newFeaturesExcluded = isChecked
      ? [...featuresExcluded, getFeaturesExcludedObject(feature)]
      : [...toggleArrayValue(featuresExcluded, null, featureExcludedIndex)];
    let newFeaturesIncluded = isChecked
      ? [...toggleArrayValue(featuresIncluded, null, featureIncludedIndex)]
      : [...featuresIncluded, getFeaturesExcludedObject(feature)];
    // console.log("newFeaturesExcluded", newFeaturesExcluded);
    wizardPopupDispatch({
      type: wizardPopupAction,
      payload: {
        featuresExcluded: newFeaturesExcluded,
        featuresIncluded: newFeaturesIncluded,
      }
    })
  }

  return (
    <li className="wizard-feature">
      <div className="wizard-feature__thumbnail" onClick={toggleExcluded}>
        <img className="wizard-feature__thumbnail-img"
             src={feature.imageUrl}
             alt=""
             onLoad={() => setThumbnailLoaded(true)}/>
        {!thumbnailLoaded ? <div className="ui-loader"/> : null}
        <CheckBox checked={isChecked} onChecked={() => null} text=""/>
      </div>
      <span className="wizard-feature__name">{feature.name}</span>
      <div className="wizard-feature__info">
        {feature.sku ? <span className="wizard-feature__info-sku">{feature.sku}</span> : null}
        <span className="wizard-feature__info-price">${feature.price}</span>
      </div>
    </li>
  )
};

WizardPopupFeaturesExclusionFeature.propTypes = {
  feature: PropTypes.object.isRequired
}

export default WizardPopupFeaturesExclusionFeature
